/**
 * OVERLAYS registry — modal overlays that float over any central-column mode
 * (chat, main expanded, main split). See UI_TAXONOMY.md §4 for slot rules.
 *
 * Currently empty — the framework is wired up so that when a real overlay
 * need arises (confirm dialogs, file pickers, blocking forms) it's a
 * one-entry-in-registry job. Usage pattern:
 *
 *   const { showOverlay, closeOverlay } = useLayoutStore();
 *   showOverlay('confirm-delete', { onConfirm: () => { ... }, itemName: 'файл.pdf' });
 *
 * The overlay component receives its props spread onto it plus `onClose`.
 */

import type { ComponentType } from 'react';

export interface OverlayEntry {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
  /**
   * Whether clicking the backdrop closes the overlay. Default true.
   * Set to false for important actions you don't want dismissed by accident
   * (delete confirms, unsaved changes, etc).
   */
  dismissOnBackdrop?: boolean;
}

export const OVERLAYS: Record<string, OverlayEntry> = {
  // No overlays registered yet. See UI_TAXONOMY.md §9.4 for how to add one.
};
